import { useArtistsData } from "@/contexts/ArtistsDataContext"

export function useCities() {
  const { cities, cityArtistCountByCity, cityCountryByCity, loading, error } = useArtistsData()

  return { cities, cityArtistCountByCity, cityCountryByCity, loading, error }
} 